import { useState, useCallback, useRef, useEffect } from "react";
import { useAppSelector } from "../../../../../utils/hooks/hooks";
import { RootState } from "../../../../../store/app";
import { Button, message, Typography, Table, Input, Space } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { renderNA, } from "../../../../../utils/commonFunctions";
import { SearchOutlined } from '@ant-design/icons';
import type { InputRef, TableColumnsType, TableColumnType } from 'antd';
import type { FilterDropdownProps } from 'antd/es/table/interface';
import { Tag } from 'antd';
import ContentBox from "../../../../../components/ContentBox/ContentBox";

import columnDefs from "./AllExamColumnDefs";
import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
// import { setGrid, setAccessCodesGrid } from "../../utils/slice";
import { AgGridReact } from "ag-grid-react";
import Config from "../../../../../config/Config";
import React from "react";
import ActionButtons from "../../../../../components/ActionButtons";
const { Title, Link } = Typography;

/**
 * Renders the Listing component for AccessCodeListing module.
 *
 * @return {JSX.Element} The rendered Listing component.
 */


const AllExamList: React.FC<any> = ({
    moduleInfo,
    handleViewInterestAssessmentClick,
    handleViewSkillAssessmentClick,
    handleViewAssessmentResultClick,
    user_id,
}) => {
    const allExamDetails = useAppSelector((state: RootState) => state.user.allExamDetails);


    const [statusData, setStatusData] = useState<any>(null);
    const [rowData, setRowData] = useState([]);
    useEffect(() => {
        console.log('allExamDetails', allExamDetails);
        setStatusData({
            reportingCurrency: "EUR",
        })
        setRowData(allExamDetails);
        return () => {
            setStatusData(null)
            setRowData([])
        }
    }, [])





    const ActionRenderer = (props: any) => {
        console.log('props', props)
        const exam_status = props.data?.exam_status_flag;
        return (
            <ActionButtons
                data={props}
                viewInterestAssessment={{
                    action: ['1', '2'].includes(exam_status) ? handleViewInterestAssessmentClick : false,
                    permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
                }}
                viewSkillAssessment={{
                    action: ['2'].includes(exam_status) ? handleViewSkillAssessmentClick : false,
                    permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
                }}
                viewAssessmentResult={{
                    action: ['2'].includes(exam_status) ? handleViewAssessmentResultClick : false,
                    permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
                }}
                // viewInterestAssessment={{
                //     action: handleViewInterestAssessmentClick,
                //     permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
                // }}
                // viewSkillAssessment={{
                //     action: handleViewSkillAssessmentClick,
                //     permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
                // }}
                // viewAssessmentResult={{
                //     action: handleViewAssessmentResultClick,
                //     permissionKey: `${moduleInfo.permissionKeyPrefix}_DETAILS`,
                // }}

            />
        );
    };


console.log('ActionRenderer',ActionRenderer)
    return (
        <>
            <ContentBox>

                <AgGridWrapper
                    components={{
                        ActionRenderer,
                    }}
                    className="all-exam-table"
                    columnDefs={columnDefs}
                    rowData={rowData}
                    // context={{ setStatusData }}
                    // onGridReadyWithDispatch={setAccessCodesGrid}
                    paginationPageSize={10}
                    cacheBlockSize={10}

                />
            </ContentBox>



        </>
    );
};

export default AllExamList;
